export const enum EStepQuestionarioDemanda {
  'DadosdoRequisitante' = 1,
  'DefinicaodoProcesso' = 2,
  'Arquivos' = 5,
  'ControladoriaOuControleFinanceiro' = 8,
  'DadosRequisicao' = 41,
}

export const enum EStepQuestionarioDemandaNovaContratacao {
  'DadosdaDemanda' = 3,
  'DadosQuantitativos' = 4,
}

export const enum EStepQuestionarioDemandaFaturamentoDireto {
  'DadosdaDemanda' = 3,
  'Arquivos' = 4,
  'Aprovacao' = 5
}

export const enum EStepQuestionarioDemandaAditivo {
  'IdentificacaodoContrato' = 3,
  'DefinicaoAditivo' = 4,
}

export const enum EStepQuestionarioDemandaValidacao {
  'PreContratacao' = 6,
}

export const enum EStepQuestionarioDemandaMinuta {
  'MinutadeContrato' = 7,
}

export const enum EStepQuestionarioDemandaRequisicao {
  'ObjetoeJustificativa' = 30, // 8
  'ItemdeServicoeAlocacaodeCusto' = 31, // 9
  'ValorDirecionamentoeEmergencial' = 32, // 10
  'AguardandoAprovacaoRC' = 33, // 11
  'AguardandoSuprimentos' = 34, // 12
  '13Final' = 35
}

export const  enum EStepQuestionarioDemandaRequisicaoModificacao {
  'ObjetoeJustificativa' = 36,
  'ItemdeServicoeAlocacaodeCusto' = 37,
  'ValorDirecionamentoeEmergencial' = 38,
  'AguardandoAprovacaoRC' = 39,
  'AguardandoSuprimentos' = 40,
  'RevalidacaoEconomica' = 42
}

export const enum EStepQuestionarioDemandaReavaliacaoRC {
  'DefinicaoReavaliacao' = 43,
  'AguardandoSuprimentos' = 44,
  'RevalidacaoEconomica' = 45,
  'ObjetoeJustificativa' = 46,
  'ItemdeServicoeAlocacaodeCusto' = 47,
  'ValorDirecionamentoeEmergencial' = 48,
  'AguardandoAprovacaoRC' = 49,
}
